module.exports = __webpack_public_path__ + "static/my-last-supper-b93e9f3b8e126d53d72eb59fc9c65aa4.jpg";